/*
 * Insert item at point in array
 */
export default (n, ins, arr) => {
  n = n < 0 ? 0 : n;
  return [...arr.slice(0, n), ins, ...arr.slice(n)];
};
